import { defineComponent as _defineComponent } from 'vue'
import BulkUpdateWrapper from '../common/BulkUpdateWrapper.vue'
import { computed, ref, onMounted } from 'vue'
import { JobJson } from '@/models/types/job-json'
import { BulkUpdateResponse } from '@/models/types/bulk-update-response'
import { SimpleField } from '@/utils/field-schema-helper'
import { ContextualizedFormResolver } from '@/utils/forms/contextualized-form-resolver'
import { FormContext } from '@/utils/forms/form-context'
import { validateFormData } from '@/utils/forms/form-validate'
import { resolveFormDataForValidation } from '@/utils/forms/form-resolver'
import { bulkUpdateCustomField } from '@/api/jobs'


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkUpdateCustomFieldForm',
  props: {
    buttonLabel: null,
    selectedJobs: null,
    customField: null
  },
  emits: ["dismiss", "updated"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'dismiss')
  (e: 'updated', { message, updatedJobs }: BulkUpdateResponse)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  buttonLabel: string
  selectedJobs: JobJson[]
  customField: SimpleField
}





const error = ref(false)
const saving = ref(false)
const errorSchema = ref<object>({})
const customData = ref<unknown>()
let initialCustomDataValue: unknown | undefined

onMounted(() => {
  const selectedCustomDataValue: Set<unknown> = new Set(
    props.selectedJobs.map((job) => job.extension_data[props.customField.key])
  )
  if (selectedCustomDataValue.size === 1) {
    initialCustomDataValue = [...selectedCustomDataValue][0]
  }
  customData.value = initialCustomDataValue
})

const formTitle = computed<string>(() => {
  return props.customField.definition.title
})
const hasChanges = computed<boolean>(() => {
  return customData.value !== initialCustomDataValue
})
const showHint = computed<boolean>(() => {
  return !customData.value && initialCustomDataValue === undefined
})

const hubId = computed<string>(() => {
  return props.selectedJobs[0].hub_id
})
const rootSchema = computed<object>(() => {
  return {
    type: 'object',
    properties: {
      [props.customField.key]: props.customField.definition,
    },
    required: props.customField.required ? [props.customField.key] : [],
  }
})

const fieldDefinitionSchema = computed<object>(() => {
  return props.customField.definition
})

// contextualizedFormResolver and validateCustomFields have been simplified because
// we know the schema wont have any nested sub schemas or dependencies
const contextualizedFormResolver = computed<any>(() => {
  const context = new FormContext({})
  return new ContextualizedFormResolver(context)
})
const validateCustomFields = () => {
  const resolvedData = resolveFormDataForValidation({
    [props.customField.key]: customData.value,
  })
  const errorSchema = validateFormData(rootSchema.value, resolvedData)

  return errorSchema[props.customField.key] ?? {}
}

const updateCustomData = (value) => (customData.value = value)

const clearSnackbar = () => (error.value = false)
const dismiss = () => emits('dismiss')

const save = async () => {
  saving.value = true
  try {
    errorSchema.value = validateCustomFields()
    if (Object.keys(errorSchema.value).length > 0) {
      saving.value = false
      return
    }
    await bulkUpdateCustomField(
      props.selectedJobs.map((job) => job.id),
      props.customField.key,
      customData.value
    )
    const updatedJobs: JobJson[] = props.selectedJobs.map(({ ...job }) =>
      Object.assign(job, {
        extension_data: {
          ...job.extension_data,
          [props.customField.key]: customData.value,
        },
      })
    )
    emits('updated', {
      message: `${props.customField.definition.title} updated`,
      updatedJobs,
    })
  } catch (err) {
    error.value = true
  } finally {
    saving.value = false
  }
}

return { __sfc: true,emits, props, error, saving, errorSchema, customData, initialCustomDataValue, formTitle, hasChanges, showHint, hubId, rootSchema, fieldDefinitionSchema, contextualizedFormResolver, validateCustomFields, updateCustomData, clearSnackbar, dismiss, save, BulkUpdateWrapper }
}

})